import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ChatToMeItem from './ChatToMeItem';
import Loading from '../common/Loading.js';
import Compose from '../message/Compose';
import ArtistService from '../../services/artistService';
import ToastrService from '../../services/toastrService';
import ErrorMessage from '../common/ErrorMessage';
import * as browserCheck from '../../utils/browserCheck.js';

class ChatToMe extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.composeMessage = this.composeMessage.bind(this);
        this.addComment = this.addComment.bind(this);
        this.state = {
            commentText: '',
            privateMessage: false
        };
    }

    componentDidMount() {  
        if((!this.props.artist.Comments && !this.props.artist.CommentsStatus) || this.props.artist.CommentsStatus === 'FAILED') {
            this.props.actions.getComments(this.props.artist.Username);
        }
        if(browserCheck.canUseDom()) {                
            window.componentHandler.upgradeDom();      
        }
    }

    componentDidUpdate(prevProps) {
   
    }

    canSendMessage() {
        return this.props.user && this.props.activeProfile && this.props.artist.CommentsEnabled;
    }

    canComment() {
        return this.props.user && this.props.activeProfile && this.props.artist.CommentsEnabled;
    }

    getCannotCommentReason() {
        if(!this.props.user) {
            return 'You need to log in to be able to post comments';
        }
        else if(!this.props.activeProfile) {
            return 'You need to create a profile to be able to post comments';
        }
        else if(!this.props.artist.CommentsEnabled) {
            return 'Sorry, you cannot post comments on this profile';
        }
        //there shouldn't be any other reason...
        return 'Sorry, you cannot post comments on this profile';        
    }

    composeMessage(event) {
        event.preventDefault();
        this.setState({ privateMessage: true });
    }

    addComment(event) {
        event.preventDefault();
        if(!this.state.commentText) {
            this.setState({ error: 'Please enter a comment' });
        }
        else {
            this.props.actions.addComment(this.props.artist.Username, this.props.activeProfile.ID, this.state.commentText)
                .then(comment => {
                    const toastrService = new ToastrService();
                    toastrService.showSuccess('', `Your comment has been saved successfully${!comment.Approved ? ' and is pending approval': ''}`);
                    //reload the comments
                    this.props.actions.getComments(this.props.artist.Username, true);
                    this.setState({ commentText: '' });
                })
                .catch(error => this.setState({ error: error.message }));   
        }       
    }

    getTo(artist) {
        return [{
            ID: artist.RoleID, 
            Username: artist.Username, 
            DisplayName: artist.Name,
            RoleType: artist.RoleType
        }];
    }

    render() {
        const artist = this.props.artist;
        const actions = this.props.actions;
        const canComment = this.canComment();
        const user = this.props.user;
        const activeProfile = this.props.activeProfile;
        return (
            artist.CommentsStatus === 'FAILED' ?
                <ErrorMessage error="Sorry, something went wrong! Unable to load comments." />
                :
                <div id="chat" className="chatbox">    
                    {
                        this.state.privateMessage ?
                            <Compose activeProfile={this.props.activeProfile} isReply={false} to={this.getTo(artist)} />
                            :
                            <React.Fragment>
                                {this.canSendMessage()?
                                    <a href="#" className="btn-sendmessage btn-small transition hidden-xs" onClick={this.composeMessage}>Send me a private message</a>
                                    : null
                                }
                                <h3>Write on my wall</h3>
                                <form id="frmAddComment" onSubmit={this.addComment} className="form-regular">
                                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                                    <div className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label${!canComment ? ' is-disabled' : ''}`} style={{width:"100%"}}>
                                        <div>    
                                            <textarea className="mdl-textfield__input" cols="20" id="Text" name="Text" rows="2" maxLength="300" value={canComment ? this.state.commentText : this.getCannotCommentReason()} onChange={(e) => this.setState({ commentText: e.target.value })} disabled={!canComment ? 'disabled' : ''} />              
                                            {
                                                canComment ?
                                                    <label className="mdl-textfield__label" htmlFor="Text">Comment:</label>    
                                                    : null
                                            }                                                                                
                                        </div>                                    
                                    </div>
                                    <div className="form-group">
                                        <input type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent btn-filter" disabled={!this.canComment()} value="Post comment" />
                                    </div>
                                </form>
                    
                                <ul id="ulComments" className="list-unstyled itemlist commentlist">
                                {artist.Comments && artist.Comments.length > 0 ?
                                    artist.Comments.map((comment) => <ChatToMeItem key={comment.ID} comment={comment} artist={artist} actions={actions} user={user} activeProfile={activeProfile} />)
                                    :
                                    (artist.CommentsStatus === 'LOADING' ?
                                        <Loading /> : null)}
                                </ul>
                            </React.Fragment>
                    }                
                </div>
        );
    }
}

ChatToMe.propTypes = {
    artist: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    user: PropTypes.object,
    activeProfile: PropTypes.object
};

export default ChatToMe;